/**
 * 青山科技页面
 */
import React from 'react';
import { APPLY_YEAR } from '../../../utils/config';
import './qa.scss';
import AwardHeader from '../../../components/AwardHeader/AwardHeader';
import FAQ from './faq';
const QA = () => {
  return (
    <div className="award-qa">
      <AwardHeader />
      <div className="about-award block-container marker" style={{ marginTop: 150 }}>
        <span className="title">常见问题解答（{APPLY_YEAR}年度）</span>
        <div className="regulation">
          <FAQ />
        </div>
      </div>
    </div>
  );
};

export default QA;
